export const VERIFICATION_OF_RENTAL_STATUS_RENT = 'rent';
export const VERIFICATION_OF_RENTAL_STATUS_OWN = 'own';
export const VERIFICATION_OF_RENTAL_STATUS_NO_HISTORY = 'noHistory';

export const verificationOfRentalOptionItems = [
  {
    label: 'I am a renter',
    value: VERIFICATION_OF_RENTAL_STATUS_RENT,
  },
  {
    label: 'I am a homeowner',
    value: VERIFICATION_OF_RENTAL_STATUS_OWN,
  },
  {
    label: 'I have no rental history',
    value: VERIFICATION_OF_RENTAL_STATUS_NO_HISTORY,
  },
];
